<div class="dns-header">
    <div class="dns-header-copy">
        <ng-content></ng-content>
        <div class="text-top" *ngIf="!embedded">
            <div class="d-flex justify-content-between align-items-center w-100">
                <span>Record DNS società</span>
            </div>
        </div>
    </div>
    <form class="dns-toolbar" (submit)="$event.preventDefault(); searchRecords()">
        <input
            type="search"
            class="form-control form-control-solid"
            [(ngModel)]="searchText"
            name="dnsSearch"
            placeholder="Cerca società o hostname"
            (keyup.enter)="searchRecords()"
        />
        <button type="submit" class="btn btn-primary">Cerca</button>
        <button type="button" class="btn btn-reset-link" *ngIf="searchText" (click)="resetSearch()">Reset</button>
    </form>
</div>

<ui-table #domainsTable [initialLoading]="true">
    <ng-template #customLoading>
        <div class="dns-skeleton">
            <div class="dns-skeleton-row" *ngFor="let row of skeletonRows">
                <div class="dns-skeleton-icon animate-pulse"></div>
                <div class="dns-skeleton-copy">
                    <div class="dns-skeleton-line dns-skeleton-line-title animate-pulse"></div>
                    <div class="dns-skeleton-line dns-skeleton-line-host animate-pulse"></div>
                </div>
                <div class="dns-skeleton-line dns-skeleton-line-target animate-pulse"></div>
                <div class="dns-skeleton-line dns-skeleton-line-status animate-pulse"></div>
                <div class="dns-skeleton-actions">
                    <div class="dns-skeleton-btn animate-pulse"></div>
                    <div class="dns-skeleton-btn animate-pulse"></div>
                    <div class="dns-skeleton-btn animate-pulse"></div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #customHeader>
        <tr>
            <th>Record</th>
            <th>Destinazione</th>
            <th>Stato</th>
            <th>Azioni</th>
        </tr>
    </ng-template>
    <ng-template #customRow let-row="row">
        <tr>
            <td>
                <div class="dns-identity">
                    <div class="dns-icon" [class.is-shop]="row.field === 'shopDomain'" aria-hidden="true">
                        <i class="bi" [ngClass]="row.field === 'shopDomain' ? 'bi-bag' : 'bi-building'"></i>
                    </div>
                    <div class="dns-identity-text">
                        <div class="dns-title-row">
                            <a class="dns-company" [routerLink]="['/companies/' + row.companyId + '/settings']">
                                {{ row.companyName || row.companyId }}
                            </a>
                            <span class="badge badge-unknown">{{ fieldLabel(row.field) }}</span>
                        </div>
                        <button
                            type="button"
                            class="dns-copy"
                            (click)="copyValue(row.name, 'host-' + row.id)"
                            [attr.title]="'Copia ' + row.name"
                        >
                            <i class="bi" [ngClass]="copiedKey === 'host-' + row.id ? 'bi-check2' : 'bi-globe2'" aria-hidden="true"></i>
                            <span>{{ row.name }}</span>
                        </button>
                    </div>
                </div>
            </td>
            <td>
                <button
                    type="button"
                    class="dns-copy"
                    *ngIf="row.content; else noTarget"
                    (click)="copyValue(row.content, 'target-' + row.id)"
                    [attr.title]="'Copia ' + row.content"
                >
                    <i class="bi" [ngClass]="copiedKey === 'target-' + row.id ? 'bi-check2' : 'bi-clipboard'" aria-hidden="true"></i>
                    <span>{{ row.content }}</span>
                </button>
                <ng-template #noTarget>
                    <span class="text-muted">—</span>
                </ng-template>
            </td>
            <td>
                <span
                    class="badge"
                    [class.badge-success]="row.recordId"
                    [class.badge-warning]="!row.recordId"
                >
                    <i class="bi me-1" [ngClass]="row.recordId ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'" aria-hidden="true"></i>
                    {{ row.recordId ? 'Attivo' : 'Mancante' }}
                </span>
            </td>
            <td>
                <div class="dns-actions">
                    <a
                        class="btn welldone-btn-gray"
                        [routerLink]="['/companies/' + row.companyId + '/settings']"
                        [attr.aria-label]="'Apri società ' + (row.companyName || '')"
                        title="Apri società"
                    >
                        <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>
                    </a>
                    <button
                        type="button"
                        class="btn welldone-btn-gray"
                        (click)="copyValue(row.name, 'host-' + row.id)"
                        [attr.aria-label]="'Copia hostname ' + row.name"
                        title="Copia hostname"
                    >
                        <i class="bi" [ngClass]="copiedKey === 'host-' + row.id ? 'bi-check2' : 'bi-clipboard'" aria-hidden="true"></i>
                    </button>
                    <button
                        type="button"
                        class="btn welldone-btn-danger"
                        (click)="deleteRecord(row)"
                        [attr.aria-label]="'Elimina record ' + row.name"
                        title="Elimina record"
                    >
                        <i class="bi bi-trash" aria-hidden="true"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
</ui-table>
